import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faKeyboard, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const LocalLinks = ({ setState }) => (
	<div className="locallinks">
		<div class="exitbtn" onClick={() => setState('home')}>
			<FontAwesomeIcon icon={faArrowLeft} className="exitbtn__icon" />
		</div>
		<a href="http://94.181.190.26/10v/skripko/27102022" class="locallinks__entry">27102022 <div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/DZ_27102022" class="locallinks__entry">27102022 (ДЗ)<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/auth10112022" class="locallinks__entry">auth10112022<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href='http://94.181.190.26/10v/skripko/test_10112022' class='locallinks__entry'>test_10112022_dz<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/a12-nav" class="locallinks__entry">Android 12 app navigation<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/oldindexpage" class="locallinks__entry">Old index page (very heavy)<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/form" class="locallinks__entry">First try with forms<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/cards" class="locallinks__entry">Cards<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
		<a href="http://94.181.190.26/10v/skripko/test" class="locallinks__entry">Another variant of index page<div className="entranceind">
			<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
		</div></a>
	</div>
)

export default LocalLinks;
